import template from 'text!./templates/ho-additional-interests-edit.html';

export default [function () {
    return {
        template: template,
        'restrict': 'E',
        'scope': {
            next: '&',
            additionalInterests: '=',
            productCode: '='
        },
        'controller': ['$scope', 'endorsement.GenericProductCodeUtil', 'ViewModelService', 'LocaleService', function ($scope, GenericProductCodeUtil, ViewModelService, LocaleService) {

            setDefaultNewEntry();

            $scope.isAddingNew = false;
            $scope.isRemoving = false;
            $scope.isReplacing = false;
            $scope.isEditing = false;
            $scope.selectedEntry = -1;

            /**
             * Begin adding a new entry
             */
            $scope.onAddNew = function () {
                setDefaultNewEntry();
                $scope.isRemoving = false;
                $scope.isReplacing = false;
                $scope.isEditing = false;
                $scope.isAddingNew = true;
            };

            /**
             * Cancel the new entry form
             */
            $scope.cancelNewEntry = function () {
                $scope.isAddingNew = false;
            };

            /**
             * Submit the new entry form
             */
            $scope.submitNewEntry = function () {
                $scope.additionalInterests.push($scope.newMortgagee.value);
                $scope.isAddingNew = false;
            };

            /**
             * Begin editing an entry
             */
            $scope.onEdit = function () {
                $scope.isAddingNew = false;
                $scope.isRemoving = false;
                $scope.isReplacing = false;
                $scope.selectedEntry = -1;
                $scope.isEditing = true;
            };

            /**
             * Update an entry
             */
            $scope.updateEntry = function () {
                $scope.isEditing = false;
                $scope.selectedEntry = -1;
            };

            /**
             * Stop editing an entry
             */
            $scope.cancelEdit = function () {
                $scope.isEditing = false;
                // Restore the model to its previous value
                $scope.additionalInterests[$scope.selectedEntry] = angular.copy($scope.modelBackup);
                $scope.selectedEntry = -1;
            };

            /**
             * Begin removing entries
             */
            $scope.onRemove = function () {
                $scope.isAddingNew = false;
                $scope.isReplacing = false;
                $scope.isEditing = false;
                $scope.selectedEntry = -1;
                $scope.isRemoving = true;
            };

            /**
             * Delete an entry
             * @param {Number} index
             */
            $scope.deleteEntry = function (index) {
                if (index > -1) {
                    $scope.additionalInterests.splice(index, 1);
                    $scope.selectedEntry = -1;

                    if ($scope.additionalInterests.length === 0) {
                        $scope.cancelRemove();
                    }
                }
            };

            /**
             * Stop removing entries
             */
            $scope.cancelRemove = function () {
                $scope.isRemoving = false;
            };

            /**
             * Select an entry
             * @param {Number} index
             */
            $scope.selectEntry = function (index) {
                $scope.selectedEntry = index;
                $scope.modelBackup = angular.copy($scope.additionalInterests[$scope.selectedEntry]);
                $scope.editingMortgagee = ViewModelService.create($scope.additionalInterests[$scope.selectedEntry], 'pc', 'edge.capabilities.policyjob.lob.homeowners.coverables.dto.AdditionalInterestDTO');
            };

            /**
             * Begin replacing an entry
             */
            $scope.onReplace = function () {
                setDefaultNewEntry();
                $scope.isAddingNew = false;
                $scope.isRemoving = false;
                $scope.isEditing = false;
                $scope.selectedEntry = -1;
                $scope.isReplacing = true;
            };

            /**
             * Replace an entry by removing one and adding a new one
             */
            $scope.replaceEntry = function () {
                if ($scope.selectedEntry > -1) {
                    $scope.additionalInterests.splice($scope.selectedEntry, 1);
                    $scope.selectedEntry = -1;
                    $scope.additionalInterests.push($scope.newMortgagee.value);
                }
                $scope.isReplacing = false;
            };

            /**
             * Cancel replacing an entry
             */
            $scope.cancelReplace = function () {
                $scope.isReplacing = false;
            };

            /**
             * Next button is clicked
             */
            $scope.onNext = function () {
                // Call next method on parent
                $scope.next();
            };

            /**
             * Populates a new entry with default values for use in the new entry form
             */
            function setDefaultNewEntry() {
                var mortgagee = {
                    type: GenericProductCodeUtil.getLobKeyValue('MORTGAGEE', $scope.productCode),
                    contractNumber: '',
                    description: 'Mortgage',
                    certificateRequired: false,
                    effectiveDate: new Date().toISOString(),
                    policyAdditionalInterest: {
                        contactName: '',
                        subtype: 'Company',
                        primaryAddress: {
                            addressLine1: '',
                            city: '',
                            state: '',
                            postalCode: '',
                            country: LocaleService.getCountry().code,
                            addressType: 'business'
                        }
                    }
                };

                $scope.newMortgagee = ViewModelService.create(mortgagee, 'pc', 'edge.capabilities.policyjob.lob.homeowners.coverables.dto.AdditionalInterestDTO');
            }
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/ho/directives/HOAdditionalInterestsEdit.js
// module id = 1454
// module chunks = 0